import { themeGet } from 'styled-system'
import system from 'system-components'

const BaseBadge = system({
  fontWeight: 'bold',
  height: 40,
  px: 3,
}).extend`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DefaultBadge = BaseBadge.extend`
  color: ${themeGet('colors.gray.2')};
  background-color: ${themeGet('colors.gray.5')};
  &:hover {
    color: ${themeGet('colors.white')};
    background-color: ${themeGet('colors.primary.0')};
  }
  &:active {
    background-color: ${themeGet('colors.primary.1')};
  }
`

export const ActiveBadge = BaseBadge.extend`
  color: ${themeGet('colors.white')};
  background-color: ${themeGet('colors.primary.0')};
`

export default BaseBadge



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Badge.js